// Clean stroke SVG icons for the dashboard services preview.
// Same 24x24 stroke language as the LatestServices cards; no emojis.
const baseProps = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const PreviewServiceIcon = () => (
  <svg {...baseProps} aria-hidden>
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.3-3.3a1 1 0 0 0 0-1.4l-1.6-1.6a1 1 0 0 0-1.4 0Z" />
    <path d="M4 20 10.2 13.8" />
    <path d="M5 19a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z" />
    <path d="M14 14 9 9" />
  </svg>
);

export const PreviewVehicleIcon = () => (
  <svg {...baseProps} aria-hidden>
    <path d="M5 16 6.2 9.5A2 2 0 0 1 8.2 8h7.6a2 2 0 0 1 2 1.5L19 16" />
    <path d="M4 16h16a1 1 0 0 1 1 1v2h-2.5" />
    <path d="M5 19H3v-2a1 1 0 0 1 1-1" />
    <circle cx="7.5" cy="19" r="1.8" />
    <circle cx="16.5" cy="19" r="1.8" />
    <path d="M9.3 19h5.4" />
  </svg>
);

export const PreviewDateIcon = () => (
  <svg {...baseProps} aria-hidden>
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

export const PreviewMileageIcon = () => (
  <svg {...baseProps} aria-hidden>
    <path d="M3 12a9 9 0 0 1 18 0" />
    <path d="M12 12 8.5 9.5" />
    <path d="M12 12v-3" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    <path d="M2 19h20" />
  </svg>
);

export const PreviewEmptyIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="36"
    height="36"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    aria-hidden
  >
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M7 10h10M7 14h6" />
  </svg>
);
